import React from "react";
import { TextField, Button } from '@mui/material';
import withModal from '../../Modal';

const EmailModal = (props: any) => {
    return (
        <div className='modal' style={{ display: 'block', zIndex: 1200, position: 'fixed', top: '20%' }} role='dialog'>
            <div className='modal-dialog'>
                <div className='modal-content'>
                    <div className="modal-header">
                        <h5 className="modal-title">{props.reason == 'cancel' ? 'Veranstaltung absagen' : 'Email'}</h5>
                    </div>
                    <div className='modal-body'>
                        <div className='row'>
                            <div className='col-sm-10'>
                                <TextField
                                    id="outlined-multiline-flexible"
                                    multiline
                                    label={props.reason == 'cancel' ? 'Grund für die Absage' : 'Email Text'}
                                    rows={2}
                                    fullWidth
                                    variant="outlined"
                                    value={props.value}
                                    onChange={(e:any) => props.change(e)}
                                />
                            </div>
                        </div>
                    </div>
                    <div className='modal-footer'>
                        <Button
                            className='btn'
                            color='secondary'
                            variant='contained'
                            onClick={() => props.hide()}>
                            Abbrechen
                        </Button>
                        <Button
                            className='btn btnBlue'
                            color='primary'
                            variant='contained'
                            onClick={() => props.submit()}>
                            {props.reason == 'cancel' ? 'Absagen' : 'Schicken'}
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default withModal(EmailModal)